import React, { useEffect, useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';

import '../../../scss/components/_user_management.scss';

const ResendInvitation = (props) => {

    return (
        <React.Fragment>
            <CssBaseline />
            <div className="disableuser-main">
                <Container className="disableuser-container" maxWidth="lg">
                    <div>
                        <div className="flex-cnt">
                            {(props.invitationStatus === 'Success!') ?
                                <img src={require('../../../assets/icons/resend_invitation_success.svg')} />
                                :
                                <img src={require('../../../assets/icons/resend_invitation_error.svg')} />
                            }
                            <div>
                                <label>{props.invitationStatus}</label>
                                <p>{props.invitationDescription} <b>{(props.invitationStatus) && props.activeUsername}</b></p>
                            </div>
                        </div>
                        <div className="disable-btns-cnt">
                            <Button
                                type="submit"
                                variant="outlined"
                                id="disable_btn"
                                className="blue-btn"
                                onClick={() => props.setShowInvitationStatus(false)}
                            >
                                {props.invitationTextButton}
                            </Button>
                        </div>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default ResendInvitation;